import { render, staticRenderFns } from "./AdmissionGiveConfirm.vue?vue&type=template&id=8af548e8"
import script from "./AdmissionGiveConfirm.vue?vue&type=script&lang=js"
export * from "./AdmissionGiveConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports